import { InputProps } from '@ui-system/interfaces-form';

const defaultProps: Partial<InputProps> = {
  textAlign: 'center',
};

export default defaultProps;
